import { FilterSchema } from '../../../../../core/base/interfaces/filter-schema.interface';
import { SupplierService } from '../../supplier/supplier.service';
import { GenericProductService } from '../../../settings/generic-product/generic-product.service';

/**
 * Filtres sur valeurs distinctes d'un champ produit (autocomplete `onlyDistinctField`).
 * Source unique : clé API `${field}List`, contrôle du formulaire, chargement, scroll et template en dérivent.
 */
export const PRODUCT_DISTINCT_FILTERS: { field: string; control: string; label: string }[] = [
  { field: 'label', control: 'labels', label: 'Libellé' },
  { field: 'manufacturer', control: 'manufacturer', label: 'Fabricant/Marque' },
  { field: 'conditioningUnit', control: 'conditioningUnit', label: 'Conditionnement' },
  { field: 'purchaseUnit', control: 'purchaseUnit', label: 'UA' },
];

export const PRODUCT_FILTER_SCHEMA: FilterSchema = {
  technicalIdentifier: { type: 'text' },
  reference: { type: 'text' },
  suppliers: { type: 'entity[]', resolve: { service: SupplierService, displayProperty: 'label' } },
  genericProducts: { type: 'entity[]', resolve: { service: GenericProductService, displayProperty: 'label' } },
  // Valeurs distinctes projetées : la chip est la valeur elle-même, l'état autocomplete est fusionné sur ce champ
  ...Object.fromEntries(
    PRODUCT_DISTINCT_FILTERS.map(({ field, control }) => [
      `${field}List`,
      { type: 'value[]', control, valueField: field },
    ]),
  ),
  // Booléen côté API (`@IsBoolean`), présenté par un select Oui/Non
  isSuspended: { type: 'boolean', options: 'suspensionOptions' },
};
